let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4xVfG")).then(() => parcelRequire('7WjXI'));